import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { pageUrl } from 'utilities/pageUrl';

import { trackNavigation } from './trackNavigation';

const trackedPrefixes = [
  '/booking',
  pageUrl.createAccount(),
  pageUrl.booking.confirmation(),
  pageUrl.appointments(),
  pageUrl.virtualMeeting()
];

export const BookingNavigationTracker = () => {
  const location = useLocation();
  const prevUrl = useRef<string>('');

  const trackUrlChange = (appLoadedFromHere: boolean) => {
    const url = `${location.pathname}${location.search}`;
    const trackingEnabled = trackedPrefixes.some(prefix => url.toLowerCase().startsWith(prefix));

    if (trackingEnabled && url !== prevUrl.current) {
      trackNavigation(url, location.search, appLoadedFromHere);
      prevUrl.current = url;
    }
  };

  // track initial url
  useEffect(
    () => trackUrlChange(true),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // track subsequent url changes
  useEffect(() => {
    trackUrlChange(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  // this needs to be a component child of Router to get access to history,
  // and track changes, but we don't want to render anything
  return null;
};
